import React, { useEffect, useState } from "react";
import "./CustomQuestion.scss";

import Switch from "@mui/material/Switch";
import { FilterOptionSchema } from "../Filter/filter.data";
import { INPUT_TYPE } from "../../constants/QuestionFormData";
import Filter from "../Filter/Filter";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { QuestionSchema } from "../../models/QuestionForm";
import { VENDOR_FORM_INPUT_TYPES } from "../../data/VendorForm.data";
import {
  breakPointObserver,
  ScreenSizes,
} from "../../utils/BreakpointObserver";

interface CustomQuestionProps {
  handleDeleteQuestion: (questionId: number) => void;
  question: QuestionSchema;
  handleQuestionValueChanges: (
    id: number,
    questionValues: QuestionSchema
  ) => void;
  vendorForm: boolean;
  questionIndex: number;
}
const CustomQuestion: React.FC<CustomQuestionProps> = ({
  handleDeleteQuestion,
  question,
  handleQuestionValueChanges,
  vendorForm,
  questionIndex,
}) => {
  const [questionDetail, setQuestionDetail] =
    useState<QuestionSchema>(question);
  const [selectedQuestionCategory, setSelectedQuestionCategory] =
    useState<FilterOptionSchema>(INPUT_TYPE[0]);
  const [optionIndex, setOptionIndex] = useState(-1);
  const [title, setTitle] = useState(question.question_value);
  const [options, setOptions] = useState<
    {
      id: number;
      name: string;
      checked?: boolean;
    }[]
  >(questionDetail.options);
  const [breakpoint, setBreakpoint] = useState("");

  useEffect(() => {
    breakPointObserver(setBreakpoint);
  }, [breakpoint]);

  useEffect(() => {
    setQuestionDetail(question);
  }, [question]);

  useEffect(() => {
    const inputTypeIndex = INPUT_TYPE.findIndex(
      (input) => questionDetail.input_type === input.code
    );
    if (inputTypeIndex !== -1) {
      setSelectedQuestionCategory(INPUT_TYPE[inputTypeIndex]);
    }
    setTitle(questionDetail.question_value);
    setOptions(questionDetail.options);
  }, [questionDetail]);

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleQuestionValueChanges(questionDetail.id, {
      ...questionDetail,
      isRequired: event.target.checked,
    });
  };

  const handleOptionChange = (
    index: number,
    id: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newOptions = options;
    newOptions[index] = { id, name: event.target.value };
    handleQuestionValueChanges(questionDetail.id, {
      ...questionDetail,
      options: newOptions,
    });
  };

  const addOption = () => {
    handleQuestionValueChanges(questionDetail.id, {
      ...questionDetail,
      options: [
        ...options,
        {
          id: optionIndex,
          name: `option ${questionDetail.options?.length + 1}`,
        },
      ],
    });
    setOptionIndex((prev) => prev - 1);
  };

  return (
    <div
      className={`custom-form-detail-container px-16 py-12 flex-row gap-12 ${
        !vendorForm && "custom-form-detail-container-workflow-detail"
      }`}
    >
      {/* text  */}
      {questionDetail.input_type === VENDOR_FORM_INPUT_TYPES.TEXT && (
        <>
          {" "}
          {!vendorForm && (
            <div className="flex-row align-items-center justify-content-space-between">
              <p className="xetgo-font-button name-type bold px-8 py-12">
                Text
              </p>

              {ScreenSizes.MOBILE === breakpoint && (
                <div className="flex-row align-items-center gap-18 xetgo-font-tag bold py-3 px-6">
                  <div className="flex-row align-items-center gap-14">
                    <p>Required</p>
                    <Switch
                      checked={questionDetail.isRequired}
                      onChange={handleSwitchChange}
                      size="small"
                    />
                  </div>
                  <img
                    onClick={() => handleDeleteQuestion(question.id)}
                    className="cursor-pointer"
                    height={22}
                    width={22}
                    src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240821104010-trash-2.svg"
                    alt="trash-icon"
                  />
                </div>
              )}
            </div>
          )}
          <div className="custom-form-left-box flex-1 flex-column gap-8">
            <input
              className="question-input p-12 xetgo-font-tag full-width border-box"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
                handleQuestionValueChanges(questionDetail.id, {
                  ...questionDetail,
                  question_value: e.target.value,
                });
              }}
              placeholder="Enter Question"
            />
            <input
              className="question-input p-12 xetgo-font-tag full-width border-box disable-cursor"
              value={""}
              disabled
              placeholder="Enter Answer"
            />
          </div>
        </>
      )}

      {/* paragraph  */}
      {questionDetail.input_type === VENDOR_FORM_INPUT_TYPES.PARAGPAPH && (
        <>
          {" "}
          {!vendorForm && (
            <div className="flex-row align-items-center justify-content-space-between">
              <p className="xetgo-font-button name-type bold px-8 py-12">
                Paragraph
              </p>
              {ScreenSizes.MOBILE === breakpoint && (
                <div className="flex-row align-items-center gap-18 xetgo-font-tag bold py-3 px-6">
                  <div className="flex-row align-items-center gap-14">
                    <p>Required</p>
                    <Switch
                      checked={questionDetail.isRequired}
                      onChange={handleSwitchChange}
                      size="small"
                    />
                  </div>
                  <img
                    onClick={() => handleDeleteQuestion(question.id)}
                    className="cursor-pointer"
                    height={22}
                    width={22}
                    src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240821104010-trash-2.svg"
                    alt="trash-icon"
                  />
                </div>
              )}
            </div>
          )}
          <div className="custom-form-left-box flex-1 flex-column gap-8">
            <input
              className="question-input p-12 xetgo-font-tag full-width border-box"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
                handleQuestionValueChanges(questionDetail.id, {
                  ...questionDetail,
                  question_value: e.target.value,
                });
              }}
              placeholder="Enter Question"
            />
            <textarea
              className={`answer-input description px-12 py-8 xetgo-font-tag full-width border-box disable-cursor`}
              value={""}
              placeholder="Enter Answer"
              disabled
            ></textarea>
          </div>
        </>
      )}
      {/* number  */}
      {questionDetail.input_type === VENDOR_FORM_INPUT_TYPES.NUMBER && (
        <>
          {!vendorForm && (
            <div className="flex-row align-items-center justify-content-space-between">
              <p className="xetgo-font-button name-type bold px-8 py-12">
                Number
              </p>
              {ScreenSizes.MOBILE === breakpoint && (
                <div className="flex-row align-items-center gap-18 xetgo-font-tag bold py-3 px-6">
                  <div className="flex-row align-items-center gap-14">
                    <p>Required</p>
                    <Switch
                      checked={questionDetail.isRequired}
                      onChange={handleSwitchChange}
                      size="small"
                    />
                  </div>
                  <img
                    onClick={() => handleDeleteQuestion(question.id)}
                    className="cursor-pointer"
                    height={22}
                    width={22}
                    src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240821104010-trash-2.svg"
                    alt="trash-icon"
                  />
                </div>
              )}
            </div>
          )}
          <div className="custom-form-left-box flex-1 flex-column gap-8">
            <input
              type="text"
              className="question-input p-12 xetgo-font-tag full-width border-box"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
                handleQuestionValueChanges(questionDetail.id, {
                  ...questionDetail,
                  question_value: e.target.value,
                });
              }}
              placeholder="Enter Question"
            />
            <input
              className={`answer-input px-12 py-8 xetgo-font-tag full-width border-box disable-cursor`}
              value={""}
              placeholder="Enter Answer"
              disabled
            />
          </div>
        </>
      )}

      {/* checkbox  */}
      {questionDetail.input_type === VENDOR_FORM_INPUT_TYPES.CHECKBOX && (
        <>
          {!vendorForm && (
            <div className="flex-row align-items-center justify-content-space-between">
              <p className="xetgo-font-button name-type bold px-8 py-12">
                Checkbox
              </p>
              {ScreenSizes.MOBILE === breakpoint && (
                <div className="flex-row align-items-center gap-18 xetgo-font-tag bold py-3 px-6">
                  <div className="flex-row align-items-center gap-14">
                    <p>Required</p>
                    <Switch
                      checked={questionDetail.isRequired}
                      onChange={handleSwitchChange}
                      size="small"
                    />
                  </div>
                  <img
                    onClick={() => handleDeleteQuestion(question.id)}
                    className="cursor-pointer"
                    height={22}
                    width={22}
                    src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240821104010-trash-2.svg"
                    alt="trash-icon"
                  />
                </div>
              )}
            </div>
          )}
          <div className="custom-form-left-box flex-1 flex-column gap-8">
            <input
              className="question-input p-12 xetgo-font-tag full-width border-box"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
                handleQuestionValueChanges(questionDetail.id, {
                  ...questionDetail,
                  question_value: e.target.value,
                });
              }}
              placeholder="Enter Question"
            />
            {options.map((option, ind) => (
              <div
                key={ind}
                className="flex-row align-items-center gap-10 options-container"
              >
                <input
                  type="checkbox"
                  className={`check-box disable-cursor`}
                  disabled
                />
                <input
                  type="text"
                  value={option.name}
                  onChange={(e) => handleOptionChange(ind, option.id, e)}
                  style={{
                    border: "none",
                    outline: "none",
                    backgroundColor: "transparent",
                    padding: 0,
                    width: "auto",
                  }}
                  className="xetgo-font-tag"
                />
              </div>
            ))}

            <div
              style={{ width: "fit-content" }}
              className="flex-row align-items-center gap-10 xetgo-font-tag cursor-pointer"
              onClick={addOption}
            >
              <p>Add more option</p>
              <img
                height={18}
                width={18}
                src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240826210154-Group+1171276096.svg"
                alt="add-circle-icon"
              />
            </div>
          </div>
        </>
      )}

      {/* radio button  */}
      {questionDetail.input_type === VENDOR_FORM_INPUT_TYPES.RADIO && (
        <>
          {!vendorForm && (
            <div className="flex-row align-items-center justify-content-space-between">
              <p className="xetgo-font-button name-type bold px-8 py-12">
                Radio
              </p>
              {ScreenSizes.MOBILE === breakpoint && (
                <div className="flex-row align-items-center gap-18 xetgo-font-tag bold py-3 px-6">
                  <div className="flex-row align-items-center gap-14">
                    <p>Required</p>
                    <Switch
                      checked={questionDetail.isRequired}
                      onChange={handleSwitchChange}
                      size="small"
                    />
                  </div>
                  <img
                    onClick={() => handleDeleteQuestion(question.id)}
                    className="cursor-pointer"
                    height={22}
                    width={22}
                    src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240821104010-trash-2.svg"
                    alt="trash-icon"
                  />
                </div>
              )}
            </div>
          )}
          <div className="custom-form-left-box flex-1 flex-column gap-8">
            <input
              className="question-input p-12 xetgo-font-tag full-width border-box"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
                handleQuestionValueChanges(questionDetail.id, {
                  ...questionDetail,
                  question_value: e.target.value,
                });
              }}
              placeholder="Enter Question"
            />

            {options.map((option, ind) => (
              <div
                key={ind}
                className="flex-row align-items-center gap-10 options-container"
              >
                <input
                  type="radio"
                  name={`options ${questionIndex}  `}
                  className={`check-box radio-btn disable-cursor`}
                  disabled
                />
                <input
                  type="text"
                  value={option.name}
                  onChange={(e) => handleOptionChange(ind, option.id, e)}
                  style={{
                    border: "none",
                    outline: "none",
                    backgroundColor: "transparent",
                    padding: 0,
                    width: "auto",
                  }}
                  className="xetgo-font-tag"
                />
              </div>
            ))}

            <div
              style={{ width: "fit-content" }}
              className="flex-row align-items-center gap-10 xetgo-font-tag cursor-pointer"
              onClick={addOption}
            >
              <p>Add more option</p>
              <img
                height={18}
                width={18}
                src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240826210154-Group+1171276096.svg"
                alt="add-circle-icon"
              />
            </div>
          </div>
        </>
      )}
      {/* single file  */}
      {questionDetail.input_type === VENDOR_FORM_INPUT_TYPES.FILE_UPLOAD && (
        <>
          {!vendorForm && (
            <div className="flex-row align-items-center justify-content-space-between">
              <p className="xetgo-font-button name-type bold px-8 py-12">
                Upload
              </p>
              {ScreenSizes.MOBILE === breakpoint && (
                <div className="flex-row align-items-center gap-18 xetgo-font-tag bold py-3 px-6">
                  <div className="flex-row align-items-center gap-14">
                    <p>Required</p>
                    <Switch
                      checked={questionDetail.isRequired}
                      onChange={handleSwitchChange}
                      size="small"
                    />
                  </div>
                  <img
                    onClick={() => handleDeleteQuestion(question.id)}
                    className="cursor-pointer"
                    height={22}
                    width={22}
                    src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240821104010-trash-2.svg"
                    alt="trash-icon"
                  />
                </div>
              )}
            </div>
          )}
          <div className="custom-form-left-box flex-1 flex-column gap-8">
            <input
              className="question-input p-12 xetgo-font-tag full-width border-box "
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
                handleQuestionValueChanges(questionDetail.id, {
                  ...questionDetail,
                  question_value: e.target.value,
                });
              }}
              placeholder="Enter Question"
            />
            <input
              id="single-fileInput"
              name="file"
              type="File"
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                display: "none",
              }}
              disabled
            />
            <label
              htmlFor="single-fileInput"
              className="answer-input flex-row align-items-center p-12 xetgo-font-tag flex-row full-width border-box "
            >
              <p className="xetgo-font-tag flex-row justify-content-space-between disable-cursor full-width">
                <p>Upload File</p>
                <img
                  className="upload-icon"
                  height={16}
                  width={16}
                  src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240828115442-upload+%287%29.svg"
                  alt="upload-icon"
                />
              </p>
            </label>
          </div>
        </>
      )}
      {/* multi file  */}
      {questionDetail.input_type ===
        VENDOR_FORM_INPUT_TYPES.MULTI_FILE_UPLOAD && (
        <>
          {!vendorForm && (
            <div className="flex-row align-items-center justify-content-space-between">
              <p className="xetgo-font-button name-type bold px-8 py-12">
                Multiple Upload
              </p>
              {ScreenSizes.MOBILE === breakpoint && (
                <div className="flex-row align-items-center gap-18 xetgo-font-tag bold py-3 px-6">
                  <div className="flex-row align-items-center gap-14">
                    <p>Required</p>
                    <Switch
                      checked={questionDetail.isRequired}
                      onChange={handleSwitchChange}
                      size="small"
                    />
                  </div>
                  <img
                    onClick={() => handleDeleteQuestion(question.id)}
                    className="cursor-pointer"
                    height={22}
                    width={22}
                    src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240821104010-trash-2.svg"
                    alt="trash-icon"
                  />
                </div>
              )}
            </div>
          )}

          <div className="custom-form-left-box flex-1 flex-column gap-8">
            <input
              className="question-input p-12 xetgo-font-tag full-width border-box"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
                handleQuestionValueChanges(questionDetail.id, {
                  ...questionDetail,
                  question_value: e.target.value,
                });
              }}
              placeholder="Enter Question"
            />
            <input
              id="multiple-fileInput"
              name="file"
              type="File"
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                display: "none",
              }}
              disabled
              multiple
            />
            <label
              htmlFor="multiple-fileInput"
              className="answer-input disable-cursor p-8 px-12 xetgo-font-tag full-width border-box "
            >
              <p className=" xetgo-font-tag flex-row justify-content-space-between">
                <p>Upload File</p>
                <img
                  className="upload-icon"
                  height={16}
                  width={16}
                  src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240828115442-upload+%287%29.svg"
                  alt="upload-icon"
                />
              </p>
            </label>
          </div>
        </>
      )}

      {/* date time  */}
      {questionDetail.input_type === VENDOR_FORM_INPUT_TYPES.DATE && (
        <>
          {!vendorForm && (
            <div className="flex-row align-items-center justify-content-space-between">
              <p className="xetgo-font-button name-type bold px-8 py-12">
                Date
              </p>

              {ScreenSizes.MOBILE === breakpoint && (
                <div className="flex-row align-items-center gap-18 xetgo-font-tag bold py-3 px-6">
                  <div className="flex-row align-items-center gap-14">
                    <p>Required</p>
                    <Switch
                      checked={questionDetail.isRequired}
                      onChange={handleSwitchChange}
                      size="small"
                    />
                  </div>
                  <img
                    onClick={() => handleDeleteQuestion(question.id)}
                    className="cursor-pointer"
                    height={22}
                    width={22}
                    src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240821104010-trash-2.svg"
                    alt="trash-icon"
                  />
                </div>
              )}
            </div>
          )}
          <div className="custom-form-left-box flex-1 flex-column gap-8">
            <input
              className="question-input p-12 xetgo-font-tag full-width border-box"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
                handleQuestionValueChanges(questionDetail.id, {
                  ...questionDetail,
                  question_value: e.target.value,
                });
              }}
              placeholder="Enter Question"
            />

            <div className="custom-question-date-value xetgo-font-tag">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className={`answer-input px-12 py-8 xetgo-font-tag full-width border-box disable-cursor`}
                  value={dayjs("".split("-").reverse().join("-"))}
                  format={"DD-MM-YYYY"}
                  views={["year", "month", "day"]}
                  // onChange={(event) =>
                  //   handleDateChange(event?.toDate().toISOString())
                  // }
                  disabled
                />
              </LocalizationProvider>
            </div>
          </div>
        </>
      )}

      <div className="custom-form-right-box flex-column gap-24">
        {vendorForm && (
          <Filter
            option={{
              key: "question_category_type",
              name: "Question Category",
            }}
            optionList={INPUT_TYPE}
            multipleSelection={false}
            onSelection={(val, _option) => {
              handleQuestionValueChanges(questionDetail.id, {
                ...questionDetail,
                input_type: val[0].code || "",
              });
            }}
            preSelected={[selectedQuestionCategory]}
            mode="showNames"
            showPlaceholder={true}
            direction="right"
            addNew={false}
            classname="category-filter-input"
            sort={true}
          />
        )}

        <div className="flex-row align-items-center gap-18 xetgo-font-tag bold py-3 px-6">
          <div className="flex-row align-items-center gap-14">
            <p>Required</p>
            <Switch
              checked={questionDetail.isRequired}
              onChange={handleSwitchChange}
              size="small"
            />
          </div>
          <img
            onClick={() => handleDeleteQuestion(question.id)}
            className="cursor-pointer"
            height={22}
            width={22}
            src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240821104010-trash-2.svg"
            alt="trash-icon"
          />
        </div>
      </div>
    </div>
  );
};

export default CustomQuestion;
